import React from "react";
import { Field, Form } from "formik";
import styled from "styled-components";
import CodeInput from "../../../components/inputs/CodeInput";

const StyledForm = styled(Form)`
    && {
        margin-bottom: 4px;
        min-height: 85px;
    }
`;

const StyledField = styled(Field)``;

const LoginForm = props => {
    const {
        values: { code = "" },
        handleChange,
        submitCount,
        handleBlur,
        isValid,
        setFieldTouched,
        onValidityChange
    } = props;

    const handleFormSubmit = e => {
        e.preventDefault();
    };

    const onChangeHandler = e => {
        handleChange(e);
        setFieldTouched(e.target.name, true, false);
    };

    const onBlurHandler = e => {
        handleBlur(e);
        props.onFormChange({ [e.target.name]: e.target.value });
    };

    /* eslint-disable */
    React.useEffect(() => {
        onValidityChange(isValid);
    }, [isValid]);
    /* eslint-enable */

    return (
        <StyledForm className="form-container" onSubmit={handleFormSubmit}>
            <StyledField name="code">
                {props => (
                    <CodeInput
                        onChange={onChangeHandler}
                        onBlur={onBlurHandler}
                        mask="1111 111 111"
                        placeholder="XXXX XXX XXX"
                        size="10"
                        value={code}
                        type="number"
                        submitCount={submitCount}
                        hasFeedback
                        {...props}
                    />
                )}
            </StyledField>
        </StyledForm>
    );
};

export default LoginForm;
